<template>
  <div class="el-col-24">
    <h5 class="warp-title">服务质量</h5>
    <div class="search">
      <div class="clearfix">
        <div class="search-type">
          <!-- <span class="search-title">工单ID</span> -->
          <el-input size="small" v-model.trim="customerName" placeholder="请输入客服账号/真实姓名"></el-input>
        </div>
        <div class="search-type">
          <el-radio-group v-model="specifiedTime" size="small" @change="changeDate">
            <el-radio-button :label="1">30天</el-radio-button>
            <el-radio-button :label="2">近7天</el-radio-button>
            <el-radio-button :label="3">今天</el-radio-button>
          </el-radio-group>
        </div>
        <div class="search-type">
          <span class="search-title">是否满意</span>
          <el-select class="w100" v-model="areYouSatisfied" size="small" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="满意" :value="1"></el-option>
            <el-option label="不满意" :value="2"></el-option>
          </el-select>
        </div>
        <div class="search-type">
          <span class="search-title">统计时间</span>
          <el-date-picker
            @change="changeTime"
            v-model="time"
            size="small"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="search-type" v-if="querybtn.custome_quality_query === 1">
          <el-button size="small" type="primary" @click="search()" :loading="isSearchLoading">查询</el-button>
        </div>
        <div class="search-type" v-if="querybtn.custome_quality_export === 1">
          <el-button size="small" @click="export1()" :loading="isExportLoading">导出</el-button>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      class="work"
      border
      align="center"
      style="width: 100%">
      <el-table-column
        label="客服工号"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.nickName }}
        </template>
      </el-table-column>
      <el-table-column
        label="姓名"
        align="center">
        <template slot-scope="scope">
          {{ scope.row.realName }}
        </template>
      </el-table-column>
      <el-table-column
        label="转单量"
        align="center">
        <template slot-scope="scope">
          {{scope.row.turnOrders}}
        </template>
      </el-table-column>
      <el-table-column
        label="提单量"
        align="center">
        <template slot-scope="scope">
          {{scope.row.submitOrder}}
        </template>
      </el-table-column>
      <el-table-column
        label="满意"
        align="center">
        <template slot-scope="scope">
          {{scope.row.satisfaction}}
        </template>
      </el-table-column>
      <el-table-column
        label="不满意"
        align="center">
        <template slot-scope="scope">
          {{scope.row.noSatisfaction}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template slot-scope="scope">
          <router-link target="_blank" :to="{name: 'WorkDetail', params:{id: scope.row.id}, query: {num: scope.row.nickName, name: scope.row.realName, time: specifiedTime, day: time}}">
            <span class="blue">查看详情</span>
          </router-link>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="已解决"
        align="center">
        <template slot-scope="scope">
          {{scope.row.resolved}}
        </template>
      </el-table-column>
      <el-table-column
        label="未解决"
        align="center">
        <template slot-scope="scope">
          {{scope.row.notSolved}}
        </template>
      </el-table-column> -->
      <!-- <el-table-column align="center" label="满意度">
        <el-table-column
          label="非常满意"
          align="center">
          <template slot-scope="scope">
            {{scope.row.verySatisfaction}}
          </template>
        </el-table-column>
        <el-table-column
          label="满意"
          align="center">
          <template slot-scope="scope">
            {{scope.row.satisfaction}}
          </template>
        </el-table-column>
        <el-table-column
          label="不满意"
          align="center">
          <template slot-scope="scope">
            {{scope.row.noSatisfaction}}
          </template>
        </el-table-column>
        <el-table-column
          label="未评价"
          align="center">
          <template slot-scope="scope">
            {{scope.row.noEvaluation}}
          </template>
        </el-table-column>
      </el-table-column> -->
    </el-table>
    <el-pagination
      class="mt20"
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      align='right'
      background>
    </el-pagination>
  </div>
</template>

<script>
import {queryCustomerServiceQualityList, exportCustomerServiceQualityList} from '../../api/statistics/index'
import { queryButtonPermission } from '../../api/public/auth'
export default {
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  },
  data () {
    return {
      isExportLoading: false,
      isSearchLoading: false,
      querybtn: {},
      customerName: '',
      specifiedTime: 3,
      areYouSatisfied: '',
      loading: '',
      time: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: []
    }
  },
  methods: {
    initdata () {
      let startTime = ''
      let endTime = ''
      if (this.time && this.time.length > 0) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        startTime: startTime,
        endTime: endTime,
        customerName: this.customerName,
        areYouSatisfied: this.areYouSatisfied,
        specifiedTime: this.specifiedTime,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.isSearchLoading = true
      queryCustomerServiceQualityList(data).then(info => {
        this.isSearchLoading = false
        let data = info.data
        if (info.data.resultCode === 0) {
          this.total = data.totalCount
          this.tableData = data.resultData
          let pageNum = Math.ceil(info.data.totalCount / this.pageSize)
          if (pageNum !== 0 && this.currentPage > pageNum) {
            this.currentPage = pageNum
            this.initdata()
          }
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSearchLoading = false
      })
    },
    currentChange (val) {
      this.currentPage = val
      this.initdata()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.initdata()
    },
    search () {
      this.initdata()
    },
    changeTime () {
      this.specifiedTime = ''
    },
    changeDate () {
      this.time = []
    },
    export1 () {
      let startTime = ''
      let endTime = ''
      if (this.time) {
        startTime = this.time[0]
        endTime = this.time[1]
      }
      let data = {
        customerName: this.customerName,
        specifiedTime: this.specifiedTime,
        areYouSatisfied: this.areYouSatisfied,
        startTime: startTime,
        endTime: endTime
      }
      this.isExportLoading = true
      exportCustomerServiceQualityList(data).then(info => {
        this.isExportLoading = false
        if (info.data.resultCode === 0) {
          let Url = info.data.resultData.fileDownLoadUrl
          window.open(Url)
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isExportLoading = false
      })
    }
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
.search{
  a{
    line-height: 32px;
  }
}
.el-tabs{
  margin-top: 20px;
}
.el-button + .el-button{
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Statistics/Work.vue